import { axios } from '@/utils/request'

export function getMessage (id) {
  return axios({
    url: '/message/' + id,
    method: 'get'
  })
}

export function pageMessages (query) {
  return axios({
    url: '/messages',
    method: 'get',
    params: query
  })
}

export function setRead (ids) {
  return axios({
    url: '/messages/read',
    method: 'patch',
    data: ids
  })
}

export function setAllRead () {
  return axios({
    url: '/messages/read-all',
    method: 'patch'
  })
}

export function remove (ids) {
  return axios({
    url: '/messages',
    method: 'delete',
    data: ids
  })
}
